import { render, staticRenderFns } from "./receipt-examples.vue?vue&type=template&id=340cc136&scoped=true"
import script from "./receipt-examples.vue?vue&type=script&lang=js"
export * from "./receipt-examples.vue?vue&type=script&lang=js"
import style0 from "./receipt-examples.vue?vue&type=style&index=0&id=340cc136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340cc136",
  null
  
)

export default component.exports